import type { SeriesRecording } from '../../../data/recording/types';
import { KalturaSeriesRecordingLean } from '../../composed';
import { createOnDemandResponseProfile, createSeriesRecordingFilter } from '../../factories';
import { fetchSeriesRecordingList } from '../../services';

import { processSeriesRecording } from './processing';
import { seriesRecordingRetrievedProperties } from './utils';

export async function fetchSeriesRecordings() {
  const { objects } = await fetchSeriesRecordingList<KalturaSeriesRecordingLean>({
    filter: createSeriesRecordingFilter({}),
    responseProfile: createOnDemandResponseProfile({
      retrievedProperties: seriesRecordingRetrievedProperties,
    }),
  });

  const recordings: Record<string, SeriesRecording> = {};

  objects.forEach((record) => {
    recordings[record.seriesId] = processSeriesRecording(record);
  });

  return recordings;
}
